// Изменение портфеля за сутки.
//
// Считается из того, что уже есть на клиенте: остаток по каждому активу и его
// суточный процент с рынка (market.changes). Никакой отдельной ручки для
// истории портфеля нет, и выдумывать её нельзя — цифра под балансом обязана
// быть выводимой из тех же чисел, что человек видит в списке активов ниже.
//
// Арифметика простая, но не «умножить сумму на процент»:
//   стоимость сейчас  V = остаток × курс
//   стоимость сутки назад  V₀ = V / (1 + c/100)
//   изменение = V − V₀
// Наивное V × c/100 завышает падения и занижает рост, потому что процент
// считается ОТ вчерашней цены, а не от сегодняшней.
//
// Активы без известного процента (стейблкоины на паритете, монета без данных)
// входят в базу как есть и не двигают изменение — это честнее, чем выкинуть
// их из знаменателя и получить процент по половине портфеля.

const EPS = 1e-9;

export const portfolioChange24h = (balances, market) => {
  const rows = Array.isArray(balances) ? balances : [];
  const changes = market?.changes || {};

  let now = 0;
  let then = 0;
  let known = false;

  for (const row of rows) {
    const available = Number(row?.available ?? row?.amount ?? 0);
    const rate = Number(row?.usd_rate ?? 0);
    if (!Number.isFinite(available) || !Number.isFinite(rate) || rate <= 0) continue;

    const value = available * rate;
    if (!Number.isFinite(value) || value <= EPS) continue;

    const raw = changes[String(row.currency).toUpperCase()];
    const pct = typeof raw === "number" && Number.isFinite(raw) ? raw : null;

    now += value;
    if (pct === null || Math.abs(1 + pct / 100) < EPS) {
      then += value;
      continue;
    }
    then += value / (1 + pct / 100);
    known = true;
  }

  if (!known || then <= EPS) {
    return { absolute: 0, percent: 0, known: false };
  }

  const absolute = now - then;
  return {
    absolute,
    percent: (absolute / then) * 100,
    known: true,
  };
};

export default portfolioChange24h;
